/*eslint-disable*/
import React from "react";
import footerLogo from "assets/img/home/footer-logo.png";
export default function Footer() {
  return (
    <footer className="bg-purple-900 bg-opacity-90 dark:!bg-navy-800 lg:sticky bottom-0" >
    <div className="w-full max-w-screen-xl mx-auto p-4 md:py-8 ">
      
        <div className="sm:flex sm:items-center sm:justify-between">
            <img src={footerLogo} className="h-14 mr-3" alt="Flowbite Logo" />

            <a href="https://flowbite.com/" className="flex items-center mb-4 sm:mb-0">
            </a>
            <ul className="flex flex-wrap items-center mb-6 text-sm font-medium text-gray-500 sm:mb-0 dark:text-gray-400">
                <li>
                    <a href="#" className="mr-4 hover:underline md:mr-6 ">Бидний тухай</a>
                </li>
                <li>
                    <a href="#" className="mr-4 hover:underline md:mr-6">Үйлчилгээний нөхцөл</a>
                </li>
           
                <li>
                    <a href="#" className="hover:underline">Холбоо барих</a>
                </li>
            </ul>
        </div>
        <hr className="my-6 border-gray-200 sm:mx-auto dark:border-gray-700 lg:my-8" />
        <span className="block text-sm text-gray-500 sm:text-center dark:text-gray-400">© 2023 <a href="https://flowbite.com/" className="hover:underline">Cplus solution llc</a>. All Rights Reserved.</span>
    </div>
</footer>
  );
}
